var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tools02-auto-import-log"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("自動登録履歴")])])],1),_c('PointBackHistoryList',{attrs:{"type":'ctrl'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }